<style>

    .v-label {
      font-size:18px;
      height: 25px !important;
    }

    .v-select__slot, .v-text-field__slot {
      padding-top: 5px;
    }

    .v-select__selection {
      line-height: 20px;
    }

    .v-input--selection-controls {
      margin-top: 0;
    }

    @font-face {
      font-family: "Bliss 2";
      src: url(./fonts/Bliss2/Bliss2R.otf) format("opentype");
    }

    @font-face {
      font-family: "Bliss 2";
      font-weight: bold;
      src: url(./fonts/Bliss2/Bliss2B.otf) format("opentype");
    }

    body,
    .v-application {
      font-family: "Bliss 2", Helvetica, Arial;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: "Bliss 2", Helvetica, Arial;
      font-weight: bold;
    }

    .v-application a[disabled] {
      cursor: default;
    }

    .v-application a.page-header-title {
      color: white;
      user-select: none;
    }

    .v-application a.page-header-logo:not([disabled]) {
      cursor: pointer;
    }

    .v-application button.primary:not([disabled]):hover {
      background-color: #FFF !important;
      color: #d43b2c !important;
      border: 1px solid #d43b2c;
      transition: .2s;
    }

    .hasValidationErrorIcon .v-input__prepend-inner {
      display: none !important;
    }

    .hasValidationErrorIcon.error--text .v-input__prepend-inner {
      display: inline-block !important;
    }

    .hasValidationErrorIcon.error--text .v-label {
      left: -25px !important;
    }

    .v-application .error--text,
    .v-application .red--text,
    .theme--light.v-messages.error--text {
      color: #b71c1c !important;
      caret-color: #b71c1c !important;
    }

    .snackbar-error-message .v-snack__wrapper {
      background-color: #fde8e8 !important;
      border: none;
    }

    .snackbar-error-message .v-snack__content {
      color: #c40404 !important;
    }

    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }

    .sr-only-fieldset {
      border: none;
      margin: 0;
      padding: 0;
    }

    /* WCAG AA contrast fix for Vuetify stepper inactive states.
       Default rgba(0,0,0,.38) ≈ #9e9e9e gives only 2.85:1 with white. */
    .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete) .v-stepper__step__step {
      background: #767676 !important; /* white text on #767676 = 4.54:1 */
    }
    .v-stepper__step:not(.v-stepper__step--active) .v-stepper__label {
      color: #595959 !important; /* #595959 on white = 7.0:1 */
      text-shadow: none !important;
    }

</style>

<template>
    <v-app>
        <v-app-bar app color="primary" dark>
            <a class="page-header-logo"
               v-on="navigateToPageClickHandler"
               :disabled="disableHeaderNavigation"
               role="button"
               :aria-label="pageHeaderTitle">
                <v-img src="./assets/logo.png" width="50" height="50" contain alt="MaltaPost"></v-img>
            </a>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                <a
                   class="page-header-title"
                   v-on="navigateToPageClickHandler"
                   :disabled="disableHeaderNavigation"
                   role="button"
                   >
                    <h2 class="page-header-text">{{ pageHeaderTitle }}</h2>
                </a>
            </v-toolbar-title>
        </v-app-bar>
        <v-main>
            <v-container class="px-4 py-0 fill-height" fluid>
                <v-row class="fill-height">
                    <v-col>
                        <transition name="fade">
                            <router-view></router-view>
                        </transition>
                    </v-col>
                </v-row>
            </v-container>
            <v-footer color="primary" class="py-3">
                <small class="overline white--text" role="group" aria-label="Footer information">
                    &copy; {{ year }} MaltaPost |
                    <span v-if="!isMobile()">All rights reserved | </span>Version
                    {{ version }}
                </small>
            </v-footer>
        </v-main>
        <v-overlay :value="busy">
            <div role="status"
                 aria-live="polite"
                 :aria-label="uploadProgress ? 'Uploading, ' + uploadProgress + '% complete' : 'Loading, please wait'">
                <v-progress-circular indeterminate
                                     size="64"
                                     role="progressbar"
                                     :aria-valuenow="uploadProgress || 0"
                                     aria-valuemin="0"
                                     aria-valuemax="100"
                                     :aria-label="uploadProgress ? 'Upload progress: ' + uploadProgress + '%' : 'Loading'">{{ uploadProgress ? uploadProgress + '%' : '' }}</v-progress-circular>
            </div>
        </v-overlay>
    </v-app>
</template>

<script>
import properties from "./assets/properties.json";
import router from './router'
import { createNamespacedHelpers } from "vuex";

const { mapGetters } = createNamespacedHelpers("missedDelivery");

export default {
  name: "App",

  components: {},

  data: () => ({
    sidebarMenu: false,
    pageHeaderTitle: '',
    year: new Date().getFullYear(),
    navigateToPageClickHandler: {},
    disableHeaderNavigation: false,
    version: properties.ServiceComponentVersion
  }),
  computed: {
    ...mapGetters(["busy", "uploadProgress"])
  },
  methods: {
    isMobile() {
      if (window.innerWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    updatePageHeaderTitle(route) {
      this.pageHeaderTitle = route.meta.pageHeaderTitle || '';
    },
    setNavigateToPageClickHandler(route) {
      const pageHeaderRedirectionPath =
        route.meta.pageHeaderRedirectionPath;

      this.disableHeaderNavigation = !pageHeaderRedirectionPath;

      this.navigateToPageClickHandler = this.disableHeaderNavigation ?
        {} : { click: () => this.handleNavigateToPageClick(pageHeaderRedirectionPath) };
    },
    handleNavigateToPageClick(pageHeaderRedirectionPath) {
      router.push(pageHeaderRedirectionPath).catch(() => {}); // Catch to avoid error message in console (see MissedDelivery.vue -> beforeRouteLeave)
    }
  },
  created: function () {
    this.sidebarMenu = !this.isMobile();

    this.updatePageHeaderTitle(this.$route);
    this.setNavigateToPageClickHandler(this.$route);
  },
  watch: {
    '$route'(to) {
      this.updatePageHeaderTitle(to);
      this.setNavigateToPageClickHandler(to);
    }
  }
};
</script>

<style scoped>
    @media screen and (max-width: 699px) {

      .page-header-text {
        font-size: 16px;
       }
    }
</style>
